import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import * as evaluacionService from "../../services/evaluacionService";
import { Grid, Card, CardContent, Snackbar, Alert } from '@mui/material';
import ParticipanteObjetivo from '../../components/ParticipanteObjetivo'
import MantenimientoForm from '../../components/common/MantenimientoForm';
import { useMantenimiento } from '../../hooks/useMantenimiento';
import { activeValidations as activeValidationsObjetivo, setEntity } from '../../redux/participanteObjetivoSlice';

// Mantenimiento de los objetivos asignados a un participante.
const Edit = () => {
    const objetivo = useSelector((state) => state.participanteObjetivo.entity);
    const objetivoValidation = useSelector((state) => state.participanteObjetivo.validationMessage);

    const [openMessage, setOpenMessage] = useState(false)
    const onCloseMessage = () => { setOpenMessage(!openMessage); }
    const [propsMessage, setPropsMessage] = useState({ severity: "success", message: "" });
    const dispatch = useDispatch();
    const params = useParams();
    const navigate = useNavigate();
    const { isReadOnly, setIsReadOnly } = useMantenimiento("evaluacion");

    const mensaje = (severity, texto) => {
        setPropsMessage({ severity: severity, message: texto })
        setOpenMessage(true);
    }

    const postEntity = async () => {
        if (objetivoValidation.length > 0) {
            dispatch(activeValidationsObjetivo());
            mensaje("error", objetivoValidation.join(" - "))
            return;
        }

        try {
            const response = await evaluacionService.addUpdateParticipanteObjetivo({
                id: objetivo.id,
                idParticipante: objetivo.idParticipante,
                idObjetivoCatalogo: objetivo.idObjetivoCatalogo,
                idTemaEvaluacion: objetivo.idTemaEvaluacion,
                nombre: objetivo.nombre,
                descripcion: objetivo.descripcion,
                fechaInicio: objetivo.fechaInicio,
                valorInicial: objetivo.valorInicial,
                criterioLogro: objetivo.criterioLogro,
                idEstado: objetivo.idEstado,
            })

            mensaje("success", "Se guardaron los datos con exito")
            setIsReadOnly(true)

            // Se recarga lo que se grabo, sin salir de la pantalla: la
            // cabecera desde el listado del participante (recien ahi aparece
            // con el id generado).
            const id = response.data.data;

            const lista = await evaluacionService.getsParticipanteObjetivoView(objetivo.idParticipante)
                .catch(() => []);

            const guardado = (lista || []).find((row) => row.id == id);

            if (guardado != null) dispatch(setEntity(guardado));

            // La direccion queda con el id real: si mas tarde se recarga la
            // pagina a mano, el objetivo se vuelve a mostrar.
            if (objetivo.id == 0) {
                navigate("/participanteobjetivo/edit/" + id + "/" + objetivo.idParticipante, { replace: true });
            }
        }
        catch (err) {
            console.log("Err: ", err);
            mensaje("error", err?.response?.data?.detail || "Hubo un error al guardar")
        }
    }

    return (
        <div>
            <MantenimientoForm
                title={(parseInt(params.id) === 0 ? "Nuevo" : "Editar") + " Objetivo del Participante"}
                backTo={"/participanteobjetivo"}
                onSave={postEntity}
                disabled={isReadOnly}
            >
                <Grid container spacing={1} sx={{
                    "& .MuiGrid-root>.MuiGrid-item": {
                        paddingTop: "8px"
                    },
                }}>
                    <Grid item xs={12} sm={12}>
                        <Card>
                            <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                                <ParticipanteObjetivo isReadOnly={isReadOnly} />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </MantenimientoForm>
            <Snackbar open={openMessage} autoHideDuration={5000} onClose={onCloseMessage}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                <Alert onClose={onCloseMessage} severity={propsMessage.severity}>
                    {propsMessage.message}
                </Alert>
            </Snackbar>
        </div>
    )
}

export default Edit
